import { gql } from "@apollo/client";
import { MiniCartFragment } from "../MiniCart/miniCartFragments.gql.js";
import { CartPageFragment } from "./cartPageFragments.gql";

export const CREATE_CART_MUTATION = gql`
  mutation createCart {
    cartId: createEmptyCart
  }
`;

export const CREATE_CART_AFTER_SIGN_IN = gql`
  mutation CreateCartAfterSignIn {
    cartId: createEmptyCart
  }
`;

export const ADD_ITEM = gql`
  mutation AddItemToCart($cartId: String!, $cartItem: CartItemInput!) {
    addProductsToCart(cartId: $cartId, cartItems: [$cartItem]) {
      cart {
        id
        ...MiniCartFragment
      }
      user_errors {
        code
        message
      }
    }
  }
  ${MiniCartFragment}
`;

const GET_CART_DETAILS = gql`
  query GetCartDetails($cartId: String!) {
    cart(cart_id: $cartId) {
      id
      ...CartPageFragment
    }
  }
  ${CartPageFragment}
`;

export const REMOVE_ITEM_MUTATION = gql`
  mutation removeItem($cartId: String!, $itemId: ID!) {
    removeItemFromCart(input: { cart_id: $cartId, cart_item_uid: $itemId })
      @connection(key: "removeItemFromCart") {
      cart {
        id
        ...CartPageFragment
      }
    }
  }
  ${CartPageFragment}
`;

export const UPDATE_QUANTITY_MUTATION = gql`
  mutation updateItemQuantity(
    $cartId: String!
    $itemId: ID!
    $quantity: Float!
  ) {
    updateCartItems(
      input: {
        cart_id: $cartId
        cart_items: [{ cart_item_uid: $itemId, quantity: $quantity }]
      }
    ) @connection(key: "updateCartItems") {
      cart {
        id
        ...CartPageFragment
      }
    }
  }
  ${CartPageFragment}
`;

export const ADD_WISHLIST_ITEM_TO_CART = gql`
  mutation AddWishlistItemToCart($cartId: String!, $cartItem: CartItemInput!) {
    addProductsToCart(cartId: $cartId, cartItems: [$cartItem]) {
      cart {
        id
      }
      user_errors {
        code
        message
      }
    }
  }
`;

export default {
  createCartMutation: CREATE_CART_MUTATION,
  addItem: ADD_ITEM,
  getCartDetailsQuery: GET_CART_DETAILS,
  removeItemMutation: REMOVE_ITEM_MUTATION,
  updateItemQuantityMutation: UPDATE_QUANTITY_MUTATION,
  addWishlistItemToCartMutation: ADD_WISHLIST_ITEM_TO_CART,
  createCartAfterSignInMutation: CREATE_CART_AFTER_SIGN_IN,
};
